import {
    pipe,
    keys,
    contains
} from 'core/utils';

export const bindStateFactory = (actionMap) => (state, action) => {
    const factory = actionMap[action.type] || actionMap.default;
    return factory(state, action);
};

export const isInActionMap = (action) => pipe(keys, contains(action.type));
